<template>
	<v-flex xs12>
	<v-card style="margin-bottom:2em;">
		 
		 <v-img v-if="!replace"
		 	:src="path + '/' + route.name + '/' + parseFile(getImageSource(files[0].path))"
		 	aspect-ratio="1"
		 ></v-img>
		 
		<Upload	v-if="replace" 
		upload="files/uploadSingleImageEdit"
		validate-method="checkpointsValidator/validateSingleImageTask"
	    button-text="Upload an image file"
	    :instruction-text="`Drag & drop an image (${validExtensions}) file`"
	    :validate-num-of-files="validateNumOfFiles"
	   set-valid="checkpointsValidator/setValidEdit"
	   :max-files="1"
		></Upload> 

		<v-btn @click="setReplace()" small color="primary" flat>
			 	<v-icon>backup</v-icon>&nbsp;
			 	{{getButtonText()}}
		</v-btn>
			
	<v-card-actions>
			        	<!--v-btn :disabled="!valid" @click="update()" small color="success">
			        		<v-icon>save</v-icon>
			        		{{translater.__('Save')}}
			        	</v-btn-->
						<SuccessButton :valid="valid" :onClick="() => update()"></SuccessButton>
			        	<!--v-btn @click="edit = false" small color="error">
			        		<v-icon>cancel</v-icon>
			        		{{translater.__('Cancel')}}
			        	</v-btn-->
						<ErrorButton :onClick="() => edit = false"></ErrorButton>
			        </v-card-actions>	
	</v-card>

</v-flex>
	

</template>

<script>

	import {parseFileName} from '../../../tools';
	import fileTools from '../../../tools/files';
	import SuccessButton from '../../../common/components/SuccessButton'
	import ErrorButton from '../../../common/components/ErrorButton'
	
	
	import Upload from './Upload';

	export default {
		name: 'EditSingleImageTask',
		components: {
			ErrorButton,
			SuccessButton,
			Upload
		},

		data()
		{
			return {
				replace: false
			}
		},

		created()
		{
			window.vm.$on('singleImageReplaced', () => {
				this.replace = false;
			})
		},
		
		methods: {

			setReplace()
			{
				this.replace = !this.replace;
				if(this.replace === true)
				{
					this.$store.commit('files/flushFilesToUpload')
				}

			},

			validateNumOfFiles(files, cb)
			{
				let valid = false
				if(files.length === 1)
				{
					valid = true;
				}

				cb(valid)
			},

			getButtonText()
			{
				let text = 'Upload';
				if(this.replace) { text = 'Cancel' }

				return this.translater.__(text);
			},

			parseFile(fn)
			{
				
				return parseFileName(fn);
			},

			getImageSource(path)
			{
				let lio = path.lastIndexOf('/') + 1;
				let p = path.substring(lio);

				return p;
			},

			update()
			{
				this.$store.dispatch('checkpoints/updateTask')
			}
		},

		computed: {

			validExtensions: {
				get()
				{
					const {validExtensions} = fileTools.getValidExtensions(21,
							this.$store.getters['files/validMimeTypes'])

					return validExtensions.join(', ')
				}
			},

			files: {
				get()
				{
					return this.$store.getters['checkpoints/editableTask'].question.files;
				}
			},

			translater: {
				get()
				{
					return this.$store.getters['translate/translater'];
				}
			},

			path: {
				get()
				{	
					let p = this.$store.getters['checkpoints/fullPathEdit'];
					
					return p;
				}
			},

			route: {
				get()
				{
					return this.$store.getters['routes/route']
				}
			},

			edit:{
				get()
				{
					return this.$store.getters['checkpoints/editTask'];
				},
				set(value)
				{
					this.$store.dispatch('checkpoints/setEditTask', value)
				}

			},

			valid: {
				get()
				{
					return this.$store.getters['checkpointsValidator/isValidEdit']
				}
			}

		}
	}
</script>